const ycItem = [{
    "index":"1",
    "cname": "黄山 ( 红方印 )",//品牌
    "pNmae":"zhonghua",//图片名称
    "origin":"安徽",//产地
    "price":"36",//零售价
    "isTop":"1", //是否为店长推荐0否，1是  
    "type":"烤烟型",//类型
    "jyMeasure":"10mg",//焦油量
     "yqyjMeasure":"0.9mg",//烟气烟碱量
    "ylhtMeasure":"10mg",//一氧化碳量
    "xyLength":"94mm",//烟长
    "glzcLength":"25mm",//过滤嘴长
    "packaging":"条盒软盒",//包装形式
    "total":"20",//单盒支数
    "describe":'团)有限责软)、玉溪(软公司生产，始建于1956年，其前身为玉溪烟叶复烤厂。玉溪香烟定位高端喜爱善)、、玉淺烟鹤 、玉溪(境界)更是其中的佼佼秦盒深鹮广大烟民',//描述
    "number1":"901028323499",
    "number2":"690120832"
}]
export default ycItem